exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[hreflang$=fr][data-v-26fc5a47]:after{background:url(\"https://www.ludotheque-savenay.fr/ludopen_web/demo/static/fr.svg\");background-repeat:no-repeat;padding:0 0 0 25px;content:\"\"}a[hreflang$=en][data-v-26fc5a47]:after{background:url(\"https://www.ludotheque-savenay.fr/ludopen_web/demo/static/gb.svg\");background-repeat:no-repeat;padding:0 0 0 25px;content:\"\"}.btn[data-v-26fc5a47],.dropdown-menu[data-v-26fc5a47],small[data-v-26fc5a47]{font-size:inherit}.close[data-v-26fc5a47]{font-size:21px}h5[data-v-26fc5a47]{font-size:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26fc5a47","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jeuxdetails.vue
// module id = 29
// module chunks = 0